import data from '~/assets/data/map.csv';

const findEU = d => d.country === 'EU';

export function getMapDataByKey(key) {
  return data.reduce((res, item) => {
    res[0].push({ key: item.country, value: +item[`${key}_2014`], all: +item.all_2014 });
    res[1].push({ key: item.country, value: +item[`${key}_2019`], all: +item.all_2019 });

    return res;
  }, [[], []]);
}

export function getDonutDataByKey(key, color) {
  return [2014, 2019].reduce((res, year) => {
    const allSeats = +data.find(findEU)[`all_${year}`];
    const groupSeats = +data.find(findEU)[`${key}_${year}`];
    const otherSeats = allSeats - groupSeats;

    res.push([
      { color: color, seats: groupSeats, relSeats: (groupSeats / allSeats) * 100, name: key },
      { color: '#ddd', seats: otherSeats, relSeats: (otherSeats / allSeats) * 100, name: 'others' },
    ]);

    return res;
  }, []);
}